import React, { useEffect, useState } from 'react'
import i18n from '../../../i18n'
import { ReactComponent as Filter } from '../../../assets/svg/filter.svg'
import { ReactComponent as DropdownTransparent } from '../../../assets/svg/DropdownTransparent.svg'
import { useTranslation } from 'react-i18next'
import Loading from '../../Loading'
import ClassroomFilterDropdown from '../../classroom/ClassroomFilterDropdown'

function ContentResultFilter({ data = {}, setSearchText = () => {}, searchText = '', submitClassFilter = () => {}, resetTrigger = new Date() }) {
    const { t } = useTranslation()
    const [selectedYearFilter, setSelectedYearFilter] = useState('all')
    const [selectedClassFilter, setSelectedClassFilter] = useState('all')
    const [loadingFilter, setLoadingFilter] = useState(false)
    const [loadingStaffFilter, setLoadingStaffFilter] = useState(false)
    const [selectedYearList, setSelectedYearList] = useState([])
    const [filterYears, setFilterYears] = useState([])
    const [classesOfYear, setClassesOfYear] = useState({})
    const [initialLoading, setInitialLoading] = useState(true)

    useEffect(() => {
        if (!initialLoading) {
            setSelectedYearFilter('all')
            setSelectedClassFilter('all')
        }
    }, [resetTrigger])

    const selectYearFilter = (year) => {
        setSelectedClassFilter('all')
        setSelectedYearFilter(year)
        if (year === 'all') {
            const keys = Object.keys(data)
            setSelectedYearList(keys.map((key) => data[key]).flat())
        } else setSelectedYearList(classesOfYear[year])
    }

    const selectAllClasses = () => {
        setSelectedClassFilter('all')
    }

    useEffect(() => {
        const keys = Object.keys(data)
        setFilterYears(keys)
        setSelectedYearList(keys.map((key) => data[key]).flat())
        setClassesOfYear(data)
        setInitialLoading(false)
    }, [data])

    const submit = () => {
        submitClassFilter({ class: selectedClassFilter, year: selectedYearFilter })
    }
    const reset = () => {
        submitClassFilter({ class: 'all', year: 'all' })
        setSelectedYearFilter('all')
        setSelectedClassFilter('all')
    }

    return (
        <div>
            <div className="border-t border-dashed border-[#BEBECE] mt-[24px]"></div>
            <div className="flex flex-row items-center justify-between mt-[15px]">
                <div className="bg-[#FFFFFF] py-[10px] px-[15px] rounded-full">
                    <input placeholder={t('search')} className="min-w-[270px]" id="content-search-input" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                </div>
                <ClassroomFilterDropdown
                    title={t('filterResults')}
                    filterYears={filterYears}
                    selectedYearFilter={selectedYearFilter}
                    selectYearFilter={selectYearFilter}
                    selectedClassFilter={selectedClassFilter}
                    selectedYearList={selectedYearList}
                    selectAllClasses={selectAllClasses}
                    selectClass={setSelectedClassFilter}
                    applyFilter={submit}
                    loadingFilter={loadingFilter}
                    hideStaffButton={true}
                    showResetButton={true}
                    reset={reset}
                />
            </div>
        </div>
    )
}

export default ContentResultFilter
